import { isNumber, isObject } from 'lodash';

export default {
  name: 'boundaryAccessPlugin',

  // 插件是否自动安装
  autoInstall: true,

  install (Vue, options) {
    Vue.mixin({
      data () {
        return {};
      },

      computed: {},

      created () {
        const self = this;

        /**
         * @private
         *
         * 覆写 $nextTick函数，
         * 在组件被销毁后，不再执行原有的处理逻辑
         */
        function _overrideNextTick () {
          const fn = self.$nextTick;

          self.$nextTick = function (...args) {
            if (self._isDestroyed) return;

            return fn.call(self, ...args);
          };
        }
        _overrideNextTick.call(this);

        /**
         * @private
         *
         * 注册 $setTimeout函数，
         * 在组件被销毁后，不再执行原有的处理逻辑
         */
        function _registerSetTimeout () {
          self.$setTimeout = function (fn, time) {
            const timer = setTimeout(() => {
              if (!self || self._isDestroyed) {
                clearTimeout(timer);
                return;
              }

              fn();
            }, time);

            self.$once('hook:beforeDestory', () => {
              clearTimeout(timer);
            });

            return timer;
          };
        }
        _registerSetTimeout.call(this);

        /**
         * @private
         *
         * 注册 $setInterval函数，
         * 在组件被销毁后，不再执行原有的处理逻辑
         */
        function _registerSetInterval () {
          self.$setInterval = function (fn, time) {
            const timer = setInterval(() => {
              if (!self || self._isDestroyed) {
                clearInterval(timer);
                return;
              }

              fn();
            }, time);

            self.$once('hook:beforeDestory', () => {
              clearInterval(timer);
            });

            return timer;
          };
        }
        _registerSetInterval.call(this);

        /**
         * @private
         *
         * 注册$emitDebounce函数
         * 用于在派发事件时添加防抖功能
         */
        function _registerEmitDebounce () {
          let debounceTime = 0;
          if (isNumber(self.debounce)) {
            debounceTime = self.debounce;
          } else if (isObject(self.debounce)) {
            debounceTime = self.debounce.debounceTime;
          }

          let debounceMap = {};

          self.$emitDebounce = (eventName, ...args) => {
            if (!debounceTime) {
              self.$emit(eventName, ...args);
            } else {
              debounceMap[eventName] = debounceMap[eventName] || { id: undefined, time: 0 };

              const curDate = Date.now();

              if (curDate - debounceMap[eventName].time < debounceTime) {
                clearTimeout(debounceMap[eventName].id);
              }

              debounceMap[eventName] = {
                id: self.$setTimeout(() => self.$emit(eventName, ...args), debounceTime),
                time: curDate
              };
            }
          };
        }
        _registerEmitDebounce.call(this);

        /**
         * 项目初始化执行函数
         */
        this._deprecatedWarning();
      },

      mounted () {},

      beforeDestroy () {},

      methods: {
        /**
         * @private
         *
         * 废弃警告，可由组件覆写该方法，从而进行废弃提醒
         */
        _deprecatedWarning () {}
      }
    });
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/boundaryAccess/index.js